const email = [
    'ikrar.t.w_UMCirasea1@t4t.org',
    'm.erlangga_UMCiwidey@t4t.org',
    'rully.a.a_FCCiminyak1@t4t.org',
    'zeni.s_FCCisangkuy@t4t.org',
    'g.a.condro_FCKebumen@t4t.org',
    'khoirum.m_FCPati@t4t.org'
]

export default email